import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronRight, Home, ArrowLeft } from 'lucide-react';

const Breadcrumb = ({ items, showBackButton = true }) => {
  const navigate = useNavigate();

  return (
    <div className="mb-6 flex items-center justify-between">
      <nav className="flex items-center space-x-2 text-sm">
        <Link 
          to="/dashboard" 
          className="flex items-center text-gray-500 hover:text-gray-700 transition-colors"
        >
          <Home size={16} />
        </Link>
        
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <ChevronRight size={16} className="text-gray-400" />
            {item.path ? (
              <Link
                to={item.path}
                className="text-gray-500 hover:text-gray-700 transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-gray-900 font-medium">{item.label}</span>
            )}
          </React.Fragment>
        ))}
      </nav>

      {showBackButton && (
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 px-3 py-2 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <ArrowLeft size={16} />
          Geri
        </button>
      )}
    </div>
  );
};

export default Breadcrumb;
